import {PRODUCT_STORE_NAME} from '../reducers/reducers'

export function getProductItems(state) {
    const stored = state[PRODUCT_STORE_NAME] || { }
    return stored.items
}
